export const SORT_OPTIONS = [
  {
    value: "default",
    label: "Default sorting",
  },
  {
    value: "latest",
    label: "Sort by latest",
  },
  {
    value: "lowtohigh",
    label: "Sort by price: low to high",
  },
  {
    value: "hightolow",
    label: "Sort by price: high to low",
  },
];
